import { gql } from '@apollo/client'

export const CHAT_USER_TOKEN_FRAGMENT = gql`
  fragment ChatUserTokenFields on UserChatTokenResponse {
    token
    expires_at
  }
`
